import { MoneyFlow } from '@g2-shared/api-client/generated/settlement-app';

export const MoneyFlowLabelMapper: Record<MoneyFlow, string> = {
  [MoneyFlow.PAY_IN]: 'Pay_in',
  [MoneyFlow.PAY_OUT]: 'Pay_out',
  [MoneyFlow.NONE]: 'None',
};
